// Stage 7A D2.11 — pure decision for seeding a new draft's Instagram delivery
// identity from the account-level default. Used by the compose account-picker.
//
// Rule: copy the account default into the draft ONLY when the draft hasn't already
// set an IG account (empty/whitespace) — never clobber a per-draft override. Returns
// null when there's nothing to apply (override present, or no account default).

export function igDefaultPatch(
  currentInstagramAccountId: string | null,
  account: { defaultInstagramAccountId: string | null; defaultInstagramAccountName: string | null },
): { instagramAccountId: string; instagramAccountName: string | null } | null {
  const hasOverride =
    typeof currentInstagramAccountId === 'string' && currentInstagramAccountId.trim() !== '';
  if (hasOverride) return null;
  if (!account.defaultInstagramAccountId) return null;
  return {
    instagramAccountId: account.defaultInstagramAccountId,
    instagramAccountName: account.defaultInstagramAccountName,
  };
}
